import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export default function OffersPreviewDialog({ open, onClose, offer }) {
  if (!offer) return null;

  // استخراج بيانات المتجر أو الادمن
  const storeName = offer.store ? offer.store.name_ar : "الادمن";
  const storeColor = offer.store ? "text" : "primary";

  // استخراج هدايا العرض
  const gifts = offer.gift_types || [];
  // تحقق من وجود منتجات مجانية
  const freeProductsGift = gifts.find((g) => g.name === "free_products");
  const freeProducts = freeProductsGift?.relationship?.products || [];

  return (
    <><Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        معاينة العرض
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <MDBox display="flex" flexDirection="column" gap={2}>
          {/* بيانات العرض الأساسية */}
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              اسم العرض:
            </MDTypography>
            <MDTypography variant="h6" color="text.primary">
              {offer.name}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              نوع العرض:
            </MDTypography>
            <MDTypography variant="h6" color="text.primary">
              {offer.promotion_type?.name || "-"}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              المتجر:
            </MDTypography>
            <MDTypography
              variant="h6"
              color={storeColor}
              fontWeight={storeColor === "primary" ? "bold" : "medium"}
            >
              {storeName}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              تاريخ البداية:
            </MDTypography>
            <MDTypography variant="h6" color="text.primary">
              {offer.start_date ? new Date(offer.start_date).toLocaleDateString("ar-SA") : "-"}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              تاريخ النهاية:
            </MDTypography>
            <MDTypography variant="h6" color="text.primary">
              {offer.end_date ? new Date(offer.end_date).toLocaleDateString("ar-SA") : "-"}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={2}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" minWidth={120}>
              عرض سوبر:
            </MDTypography>
            <MDTypography
              variant="h6"
              color={offer.is_super_offer ? "success.main" : "error.main"}
              fontWeight="bold"
            >
              {offer.is_super_offer ? "نعم" : "لا"}
            </MDTypography>
          </MDBox>

          {/* هدايا العرض */}
          <MDBox mt={3}>
            <MDTypography variant="h6" color="info.main" fontWeight="bold" mb={1}>
              هدايا العرض:
            </MDTypography>
            {gifts.length === 0 ? (
              <MDTypography color="text.secondary">لا توجد هدايا</MDTypography>
            ) : (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>نوع الهدية</TableCell>
                      <TableCell>القيمة</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {gifts.map((gift) => (
                      <TableRow key={gift.id}>
                        <TableCell>{gift.name}</TableCell>
                        <TableCell>{gift.relationship?.value || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </MDBox>

          {/* منتجات مجانية إذا وجدت */}
          {freeProducts.length > 0 && (
            <MDBox mt={3}>
              <MDTypography variant="h6" color="info.main" fontWeight="bold" mb={1}>
                المنتجات المجانية:
              </MDTypography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>اسم المنتج</TableCell>
                      <TableCell>الكمية</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {freeProducts.map((product, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{product.name}</TableCell>
                        <TableCell>{product.quantity}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </MDBox>
          )}
        </MDBox>
      </DialogContent>
    </Dialog>
      </>
  );
}
